import { useTranslation } from 'react-i18next';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Info, X } from 'lucide-react';
import { useState, useEffect } from 'react';

export function UpdateBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if banner was previously dismissed
    const dismissed = localStorage.getItem('update-banner-dismissed');
    if (dismissed) {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('update-banner-dismissed', 'true');
  };

  const handleUseOldVersion = () => {
    // You can implement logic here to switch to old version
    // For now, we'll just dismiss the banner
    setIsVisible(false);
    localStorage.setItem('update-banner-dismissed', 'true');
    // Could add analytics tracking here
    console.log('User chose to use old version');
  };

  if (!isVisible) return null;

  return (
    <Card 
      className="relative bg-gradient-to-r from-blue-50/50 to-indigo-50/50 dark:from-blue-950/20 dark:to-indigo-950/20 border-border/50"
      role="banner"
      aria-label="Site update notification"
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <Info className="h-5 w-5 text-blue-500 flex-shrink-0" aria-hidden="true" />
            <div className="flex-1">
              <p className="text-sm text-foreground/90">
                O design da Roda da Vida está passando por uma atualização para ficar ainda melhor!
                {/* <span className="hidden sm:inline"> Se preferir, você ainda pode usar a versão anterior.</span> */}
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            {/* <Button 
              size="sm" 
              variant="outline"
              onClick={handleUseOldVersion}
              className="text-xs px-2 py-1"
              aria-label="Use old version of the wheel"
            >
              Versão Anterior
            </Button> */}
            
            <button
              onClick={handleDismiss}
              className="p-1 hover:bg-background/80 rounded-md transition-colors text-muted-foreground hover:text-foreground"
              aria-label="Dismiss update notification"
              title="Dismiss this notification"
            >
              <X className="h-4 w-4" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </Card>
  );
}
